// VenderAuto.jsx

import React, { useState } from 'react';
import {
  Calculator,
  HandHeart,
  CheckCircle,
  Eye,
  Zap,
  TrendingUp,
  Shield,
  Star,
  Users,
  MessageCircle
} from 'lucide-react';
import Navbar from '../Navbar/Navbar';
import './VenderAutoComponent.css';
import imagen from '../../images/staticas/Vender-tu-auto-2.png';

const VenderAuto = () => {
  const [selectedOption, setSelectedOption] = useState('directa');
  const phoneNumber = "5491134567890"; // Reemplazar con el número real de WhatsApp

  // Función para redirigir a WhatsApp
  const handleWhatsappClick = (message) => {
    const defaultMessage = "Hola! Me interesa vender mi auto. ¿Podrían ayudarme?";
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message || defaultMessage)}`, '_blank');
  };

  // Función para simular el click al formulario de tasación (CTA Principal)
  const handleTasacionClick = () => {
    // En un entorno real, esto navegaría a /tasacion o abriría un modal
    console.log('Redirigiendo a formulario de tasación...');
    alert('Simulando redirección al formulario de Tasación Gratuita.');
  };

  return (
    <div className="vender-auto-page">
      {/* Navbar agregado aquí */}
      <Navbar />

      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              {/* Título y Subtítulo FILONI */}
              <h1>VENDER TU AUTO NUNCA FUE TAN FACIL</h1>
              <p className="subtitle">
                En IDO te damos la opcion de comprar tu auto pagando en efectivo y al instante, rápido y de forma transparente. Además, tenés la opción de consignar tu auto, nos ocupamos de todo.
              </p>

              <div className="cta-buttons">
                <a
                  href="https://api.whatsapp.com/send?phone=3512440118&text=¡Hola! Quiero vender mi auto y me gustaría recibir más información."
                  className="btn-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Calculator className="btn-icon" />
                  Vende tu auto
                </a>
              </div>


              {/* Indicadores de confianza se mantienen */}
              <div className="trust-indicators">
                <div className="indicator">
                  <Star className="indicator-icon" />
                  <span>+500 autos vendidos</span>
                </div>
                <div className="indicator">
                  <Shield className="indicator-icon" />
                  <span>100% transparente</span>
                </div>
                <div className="indicator">
                  <Users className="indicator-icon" />
                  <span>Clientes satisfechos</span>
                </div>
              </div>
            </div>

            <div className="hero-image imagen1">
              <div className="image-placeholder imagen1">
                <img
                  src={imagen}
                  alt="Persona vendiendo su auto"
                  className="hero-img imagen1"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Opciones de Venta */}
      <section className="options-section">
        <div className="container">
          <br />
          <br />
          <h2 className="section-title">ELEGI LA OPCION QUE MAS TE CONVIENE</h2>
          <br />
          <br />
          <div className="options-grid">
            {/* Opción 1: Venta Directa */}
            <div
              className={`option-card ${selectedOption === 'directa' ? 'active' : ''}`}
              onClick={() => setSelectedOption('directa')}
            >
              <div className="option-icon">
                <Zap className="icon" /> {/* Icono: auto + dinero (Zap es rápido) */}
              </div>
              <h3>Te lo compramos ya</h3>

              <ul className="benefits-list">
                <li><CheckCircle className="check-icon" /> Envianos un mensaje con los datos de tu auto</li>
                <li><CheckCircle className="check-icon" /> Hacemos una revisión rápida y transparente.</li>
                <li><CheckCircle className="check-icon" /> Peritamos tu auto y pagamos en el acto.</li>
              </ul>

              {/* Beneficio Destacado */}
              <div className="option-badge featured-badge">
                💡 Ideal si necesitás  <br />vender rápido y cobrar al instante.
              </div>
            </div>

            {/* Opción 2: Consignación */}
            <div
              className={`option-card ${selectedOption === 'consignacion' ? 'active' : ''}`}
              onClick={() => setSelectedOption('consignacion')}
            >
              <div className="option-icon">
                <TrendingUp className="icon" /> {/* Icono: auto + escaparate (TrendingUp es para mejor precio) */}
              </div>
              <h3>Lo vendemos por vos</h3>

              <ul className="benefits-list">
                <li><CheckCircle className="check-icon" /> Publicamos tu auto en todos nuestros canales</li>
                <li><CheckCircle className="check-icon" /> Nos ocupamos de fotos, publicaciones, atención a interesados y negociación.</li>
                <li><CheckCircle className="check-icon" /> Gestionamos todo el papeleo y transferencia.</li>
                <li><CheckCircle className="check-icon" /> Te avisamos en cuanto haya comprador para que recibas el pago.</li>
              </ul>

              {/* Beneficio Destacado */}
              <div className="option-badge featured-badge">
                💡 Ideal si querés obtener el mejor precio  posible <br /> sin preocuparte por venderlo vos mismo.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Proceso Paso a Paso */}
      <section className="process-section">
        <div className="container" style={{ paddingTop: '2rem' }}>
          <h2 className="section-title">TE EXPLICAMOS COMO FUNCIONA</h2>
          <p className="section-subtitle">Proceso simple en 3 pasos</p>
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-icon">
                <Calculator className="icon" />
              </div>
              <h3>Tasación sin compromiso</h3>
              <p> Consulta de forma online o acercate al local.</p>

            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-icon">
                <Eye className="icon" />
              </div>
              <h3>Revisión y propuesta</h3>
              <p> Revisamos el auto,<br /> verificamos documentación y te damos nuestra oferta (venta directa) o el precio estimado de venta (consignación).</p>

            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-icon">
                <HandHeart className="icon" />
              </div>
              <h3>Cierre y pago</h3>
              <p>Si aceptás, <br />firmamos y completamos la operación. <br /> Pago inmediato o transferencia cuando se concrete la venta (en consignación).</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="final-cta">
        <div className="container" style={{ paddingTop: '2rem' }}>
          <div className="cta-content">
            {/* Texto motivador FILONI */}
            <h2>PONE TU AUTO EN BUENAS MANOS</h2>
            <h3>Ya sea para venderlo hoy o para que lo mostremos a cientos de compradores,<br /> en FILONI hacemos que sea facil, <br />rápido y seguro.</h3>

            <div className="final-buttons">
              {/* Botón 1: CTA Principal (verde lima) */}

              {/* Botón 2: CTA Secundario (azul FILONI) */}
              <button className="btn-secondary large cta-azul" onClick={() => handleWhatsappClick("Hola, quiero consultar por la venta de mi auto.")}>
                <MessageCircle className="btn-icon" />
                Escribinos por WhatsApp
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VenderAuto;